/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyTreeViewRequest {
    getFixupPrototypeFunction() { return OntologyTreeViewRequest.fixupPrototype; }

    static newInstance(model: Partial<OntologyTreeViewRequest>): OntologyTreeViewRequest {
        let obj = Object.assign(new OntologyTreeViewRequest(), model);
        OntologyTreeViewRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyTreeViewRequest>): OntologyTreeViewRequest {
        if (!model) return null;
        return OntologyTreeViewRequest.newInstance(<OntologyTreeViewRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyTreeViewRequest) {
        if (!obj) return;

        models.OntologyTreeViewRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyTreeViewRequest): boolean {
        Object.setPrototypeOf(obj, OntologyTreeViewRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant to scope the tree to
     */
    tenant_id: string;

    /**
     * Pivot view, e.g. 'cloud_account', 'region', or 'dimension'
     */
    view: string;

    /**
     * Ontology entity types to include as leaf buckets
     */
    include_types: Array<string>;

}
